import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'

import classNames from 'classnames'

import { isEmpty } from '@elo-kit/utils/validators.utils'
import { COURSE_QUIZ_CLASS_NAMES } from '@elo-kit/constants/customCss.constants'
import { QUIZ_QUESTION_TYPES } from 'constants/courses.constants'

import { EloOrCustomButton } from 'utils/themes.utils'
import { ascendingSort } from 'utils/helpers.utils'

import { QuizQuestion, QuizResultItem } from '../../../../components/quiz-components'

@observer
class QuizResults extends Component {
  static isChoiceAnswered(quizAnswers, choiceId) {
    for (const answer of quizAnswers) {
      const isSelectedAnswer = answer.quizChoiceIds.includes(choiceId)
      if (isSelectedAnswer) {
        return true
      }
    }

    return false
  }

  @observable quizData = new Map()

  componentDidMount() {
    const {
      courseViewsStore: {
        courseSession: { id: courseSessionId },
        activeLesson: { id: lessonId },
      },
      quizzesStore,
    } = this.props

    quizzesStore.fetchItem(courseSessionId, lessonId)
  }

  getLastQuizAttempt() {
    const { item: quiz } = this.props.quizzesStore
    const quizAvailable = !isEmpty(quiz)
    const { quizAttempts } = quizAvailable && quiz
    const quizAttemptsLength = quizAttempts && quizAttempts.length

    // Get last attempt(saved as first on a server)
    return !!quizAttemptsLength && quizAttempts[0]
  }

  renderQuizItem = (choice, autoChecked) => {
    const { correct: isCorrect, value: answerValue, body: answerText, id: choiceId } = choice

    const { quizAnswers } = this.getLastQuizAttempt()
    const isAnswer = QuizResults.isChoiceAnswered(quizAnswers, choiceId)
    const isCorrectAnswer = isAnswer && isCorrect
    const isWrongAnswer = isAnswer && !isCorrect

    return (
      <QuizResultItem
        key={choice.id}
        {...{
          autoChecked,
          answerText,
          answerValue,
          isCorrectAnswer,
          isWrongAnswer,
        }}
      />
    )
  }

  render() {
    const {
      quizzesStore,
      courseViewsStore: { toggleQuizResults },
      defaultTheme,
    } = this.props
    const { item: quiz, loading } = quizzesStore
    const { quizQuestions = [], autoChecked } = quiz
    const quizAttempt = this.getLastQuizAttempt()

    if (!quizAttempt || loading) {
      return null
    }

    const { quizAnswers } = quizAttempt

    const continueCourseButtonProps = {
      orange: defaultTheme,
      onClick: toggleQuizResults,
      children: I18n.t('react.payer.course.continueCourse'),
    }

    const questions = ascendingSort(quizQuestions, 'id')

    return (
      <Fragment>
        {quizAttempt && (
          <div
            className={classNames(COURSE_QUIZ_CLASS_NAMES.resultsContainerClassName, 'quiz-results', 'white-widget')}
          >
            <div className='white-widget__title'>
              {I18n.t('react.payer.common.results')}
              <div className='quiz-results__close'>
                <i className='fas fa-times' onClick={toggleQuizResults} />
              </div>
            </div>

            <ul className='quiz-results__questions fr-view'>
              {questions.map((question) => {
                const { choices = [], form, id, title } = question

                if (form === QUIZ_QUESTION_TYPES.text) {
                  const textAnswer =
                    quizAnswers.find(({ quizQuestionId }) => String(quizQuestionId) === String(id)) || {}

                  return <QuizQuestion key={id} title={title} answerText={textAnswer.body} />
                }

                const quizChoices = ascendingSort(choices, 'id')

                return (
                  <Fragment key={id}>
                    <li className='quiz-results__questions fr-view'>
                      <span dangerouslySetInnerHTML={{ __html: title }} />

                      <ul className='quiz-results__choices'>
                        {quizChoices.map((choice) => this.renderQuizItem(choice, autoChecked))}
                      </ul>
                    </li>

                    <hr />
                  </Fragment>
                )
              })}
            </ul>

            <EloOrCustomButton defaultTheme={defaultTheme} {...continueCourseButtonProps} />
          </div>
        )}
      </Fragment>
    )
  }
}

QuizResults.displayName = 'QuizResults'

export default QuizResults
